module.exports = __webpack_public_path__ + "img/1440.687ca39f.jpg";